import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const SelectedUsersCount = styled.h2``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .search_input {
    width: 40%;
    border: 1px solid #d9d9d9;
  }
`;

export const ScrollDiv = styled.div`
  overflow-y: auto;
  height: 150px;
`;
